import { render, staticRenderFns } from "./ListPageHeader.vue?vue&type=template&id=bf4864ae&scoped=true&"
import script from "./ListPageHeader.vue?vue&type=script&lang=js&"
export * from "./ListPageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4864ae",
  null
  
)

export default component.exports